const loadingLabel = "Lataa...";
const fiFI = {
  loadingLabel
};
export {
  fiFI as default,
  loadingLabel
};
